import React from 'react';
import { useTranslation } from 'react-i18next';
import { PreviewFile } from '../types/PreviewFile';

type HandleRemoveAction = (index: number) => void;

interface PreviewFilesProps {
    files: PreviewFile[];
    handleRemove: HandleRemoveAction;
}

export const PreviewFiles: React.FC<PreviewFilesProps> = ({
    files,
    handleRemove,
}) => {
    return (
        <div className="row">
            {files.map((preview, index) => (
                <DisplayPreviewFile
                    key={index}
                    preview={preview}
                    index={index}
                    handleRemove={handleRemove}
                />
            ))}
        </div>
    );
};

const DisplayPreviewFile = React.memo(function DisplayPreviewFile({
    preview,
    index,
    handleRemove,
}: {
    preview: PreviewFile;
    index: number;
    handleRemove: HandleRemoveAction;
}) {
    const { t } = useTranslation();
    const isImage = preview.file.type.startsWith('image/');
    return (
        <div className="col-md-3 col-sm-4 col-6 mb-3">
            <div className="card">
                {isImage ? (
                    <img
                        src={preview.url}
                        className="card-img-top"
                        alt={`preview-${index}`}
                        style={{ height: '150px', objectFit: 'cover' }}
                    />
                ) : (
                    <PlaceHolderImage />
                )}
                <div className="card-body p-2">
                    <p
                        className="card-text small text-truncate"
                        title={preview.file.name}
                    >
                        {preview.file.name}
                    </p>
                    <button
                        data-testid={`btn-remove-${preview.file.name}`}
                        className="btn btn-sm btn-danger btn-block"
                        onClick={(e) => {
                            e.preventDefault();
                            handleRemove(index);
                        }}
                    >
                        {t('Remove')}
                    </button>
                </div>
            </div>
        </div>
    );
});

const PlaceHolderImage = () => (
    <div
        style={{
            height: '150px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f0f0f0',
        }}
    >
        <span className="file-icon">
            <i className="fa fa-file"></i>
        </span>
    </div>
);
